module.exports = __webpack_public_path__ + "static/img/success.4a6f4bc0.svg";